import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableHead from "@material-ui/core/TableHead";
import React from "react";

/**
 * This class representing SimpleTable.
 */
class SimpleTable extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Paper style={{ overflowY: "scroll", maxHeight: 800 }}>
        <Table>
          <TableHead>{this.props.tableHeaderHandler}</TableHead>
          <TableBody>{this.props.tableRowHandler}</TableBody>
        </Table>
      </Paper>
    );
  }
}

export default SimpleTable;
